import { apiClient } from "./client";

export type EnquiryCreate = {
  name: string;
  phone_no: string;
  email?: string | null;
  location: string;
  service: string;
  note?: string | null;
};

export type Enquiry = EnquiryCreate & {
  id: string;
  email: string | null;
  note: string | null;
  resolve: boolean;
};

export async function createEnquiry(payload: EnquiryCreate): Promise<Enquiry> {
  const { data } = await apiClient.post<Enquiry>("/enquiries", payload);
  return data;
}
